
$(document).ready(function() {
  var $sliderbanner = $('.banner_slider_product');
  var $progressBarBanner = $('.progresss');
  var $progressBarLabelBanner = $( '.slider__labels' );

    $sliderbanner.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      $progressBarBanner
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc );
      
      $progressBarLabelBanner.text( calc + '% completed' );
    });
    $sliderbanner.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      draggable: true,
      autoplaySpeed: 3000,
      speed: 1000,
      arrows: false,
      infinite: true,
      cssEase: 'ease-in-out',
      touchThreshold: 1000,
      arrows: false
    });
});

  
$(document).ready(function() {
  
  $('.tab_slick_1, .tab_slick_2, .tab_slick_3, .tab_slick_4, .tab_slick_5, .tab_slick_6, .tab_slick_7, .tab_slick_8').slick({
      rows: 2,
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 2
  });
  $('.tab_slick_1').slick('setPosition');

  
  // $('.c_slider_sction').slick({
  //    rows: 2,
  //    dots: true,
  //    arrows: true,
  //    infinite: true,
  //    speed: 300,
  //    arrows: false,
  //    slidesToShow: 2,
  //    slidesToScroll: 2
  // });

});
$(document).ready(function() {
  var $collabo_sction = $('.collabo_sction');
  var $progress_Bar = $('.progress_bar');
  var $progressBarLabelto = $( '.slider__labeto' );
  
  $collabo_sction.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progress_Bar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabelto.text( calc + '% completed' );
  });
  $('.collabo_sction').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    draggable: true,
    autoplaySpeed: 3000,
    speed: 1000,
    infinite: true,
    cssEase: 'ease-in-out',
    touchThreshold: 1000,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow col-slider-prev"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none" ><path d="M7.68182 15L1 8L7.68182 1" stroke="white" stroke-width="1.3"></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow col-slider-next"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none"><path d="M7.68182 15L1 8L7.68182 1" stroke="white" stroke-width="1.3"/></svg></button>',
    centerMode: true,
    centerPadding: '40px',
    asNavFor: '.collabo_sction_2'
  });
  $('.collabo_sction_2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    draggable: true,
    autoplaySpeed: 3000,
    speed: 1000,
    touchThreshold: 1000,
    arrows: false,
    infinite: true,
    asNavFor: '.collabo_sction',
    dots: true,
    arrows: false,
    focusOnSelect: true
  });
});
$(document).ready(function() {
  var $cloth_collection = $('.cloth_collection');
  var progress_bar_c = $('.progress_bar_c');
  var $progressBarLabelto = $( '.slider__labeto' );
  
  $cloth_collection.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    progress_bar_c
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabelto.text( calc + '% completed' );
  });
  $('.cloth_collection').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    
    draggable: true,
    autoplaySpeed: 3000,
    speed: 1000,
    arrows: false,
    infinite: true,
    cssEase: 'ease-in-out',
    touchThreshold: 1000,
    arrows: false,
    centerMode: true,
    centerPadding: '40px',
    asNavFor: '.cloth_collection_2'
  });
  $('.cloth_collection_2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    
    draggable: true,
    autoplaySpeed: 3000,
    speed: 1000,
    touchThreshold: 1000,
    arrows: false,
    infinite: true,
    asNavFor: '.cloth_collection',
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '40px',
    focusOnSelect: true
  });
});
$(document).ready(function () {
  const allTabsButons = $(".tabs__button");
  const allTabs = $(".tabs .tab");

  allTabsButons.click(function () {
    const thisParentCityAttr = $(this).parent().attr("data-city");
    allTabsButons.parent().removeClass("tabs__item_active");
    $(this).parent().addClass("tabs__item_active");

    allTabs.filter(".tab_active").removeClass("tab_active");
    allTabs.filter(`[data-city=${thisParentCityAttr}]`).addClass("tab_active");
  });
});
$(document).ready(function () {
  const allTabsButons = $(".tabs__buttons");
  const allTabs = $(".tabs .taba");

  allTabsButons.click(function () {
    const thisParentCityAttr = $(this).parent().attr("data-citys");
    allTabsButons.parent().removeClass("tabs__item_actives");
    $(this).parent().addClass("tabs__item_actives");

    allTabs.filter(".tab_actives").removeClass("tab_actives");
    allTabs.filter(`[data-citys=${thisParentCityAttr}]`).addClass("tab_actives");
  });
});
$(document).ready(function () {
  const allTabsButons = $(".tabsv__buttons");
  const allTabs = $(".tabs .taba_v");

  allTabsButons.click(function () {
    const thisParentCityAttr = $(this).parent().attr("data-cityv");
    allTabsButons.parent().removeClass("tabs__item_activev");
    $(this).parent().addClass("tabs__item_activev");

    allTabs.filter(".tab_activevv").removeClass("tab_activevv");
    allTabs.filter(`[data-cityv=${thisParentCityAttr}]`).addClass("tab_activevv");
  });
});
$(document).ready(function () {
  $(".bg-block:first-child").addClass("active")
  var pause = false;
  var item=  $('.select-item');
  var block=  $('.bg-block');
  var k =0;
    setInterval(function () {
        if (!pause) {
            var $this = item.eq(k);
          
          if (item.hasClass('active'))  {
            item.removeClass('active');
          };
           block.removeClass('active').eq(k).addClass('active');
            $this.addClass('active');
            k++;
            if (k >= block.length ) {
                k = 0;
            }
        }
    }, 10000);


  item.hover(function () {
        $(this).siblings().removeClass("active");
       $(this).addClass('active');
      block.removeClass('active');
      block.eq($(this).index()).addClass('active');
        pause = true;
    }, function () {
        pause = false;
    });
  
  $(".collection-close").click(function () {
      $(".shopify-section-right-collection").css("display", "none");
  });
  $(".announcement-bar-close").click(function () {
      $("#shopify-section-announcement-bar").css("display", "none");
  });

  $('.image_loop').slick({
    centerMode: true,
    centerPadding: '80px',
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1
  }).slickAnimation();
  $('.event_slider').slick({
    centerMode: true,
    centerPadding: '80px',
    arrows: false,
    slidesToShow: 1,
    responsive: [
      {
         breakpoint: 480,
         settings: {
           centerPadding: '20px'
         }
      },
      {
         breakpoint: 375,
         settings: {
           centerPadding: '5px'
         }
      }
    ]
  });
  $('.product_sec_ban').slick({
    arrows: false,
    rows:2,
    slidesToShow: 3
  });
  $('.c_product_slid').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow">‹</button>',
    nextArrow: '<button class="slide-arrow next-arrow">›</button>'
  });
  $('.brand_content').slick({
    arrows: false,
    infinite: false,
    swipeToSlide: true,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  
  $('.product_slider_b_').slick({
    infinite: true,
    slidesToShow: 3,
    centerMode: true,
    autoplay: true,
    autoplaySpeed:5000,
    centerPadding: '30px'
  })
  $('.slide_hero').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    dots: true,
    autoplay: false,
    autoplaySpeed:5000,
    focusOnSelect: true,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow">‹</button>',
    nextArrow: '<button class="slide-arrow next-arrow">›</button>',
    dots: true,
    appendDots: $('.slider-dots-box'),
	dotsClass: 'slider-dots',
  });
  $('.slide_hero').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // $(".page-info.slick-center").next().removeClass("small_image_slide");
    $('.slider-dots-box button').html('');
  }).trigger('beforeChange');

  $('.slide_hero').on('afterChange', function(event, slick, currentSlide){
  //$(".page-info.slick-center").next().removeClass("small_image_slide");
  $(this).find("page-info").addClass("small_image_slide");
  $('.slider-dots-box button').html('');
	 $('.slider-dots-box .slick-active button')
		 .html(`<svg class="progress-svg" width="40" height="40"><g transform="translate(20,20)"><circle class="circle-go" r="19" cx="0" cy="0"></circle><text class="circle-tx" x="0" y="4" alignment-baseline="middle" stroke-width="0" text-anchor="middle"></text></g></svg>`);
    }).trigger('afterChange');
  
  $('.slider_new_arr').slick({
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    autoplaySpeed: 2000
  })
  $('.announce_bar_sec').slick({
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 5000
  })
  
  $('.video_listing').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow">‹</button>',
    nextArrow: '<button class="slide-arrow next-arrow">›</button>',
    dots: false
  });
});

$(window).resize(function() {
  var windowh = $(window).height(); 
  $(".shopify-section-right-collection").css("height", windowh);
});


$(document).ready(function() {
    
    $('#single-s').click(function(){
      $('.grid--2-col-tablet-down').toggle(function() {
          $(this).toggleClass("grid--1-col-tablet-down");
          $(this).removeClass("grid--2-col-tablet-down").addClass("grid--1-col-tablet-down");
          $(this).css("display", "block");
      }, function() { 
          $(this).toggleClass("grid--1-col-tablet-down");
          $(this).removeClass("grid--2-col-tablet-down").addClass("grid--1-col-tablet-down");
          $(this).css("display", "block");
      });
      $('.grid--3-col-tablet-down').toggle(function() {
          $(this).toggleClass("grid--1-col-tablet-down");
          $(this).removeClass("grid--3-col-tablet-down").addClass("grid--1-col-tablet-down");
          $(this).css("display", "block");
      }, function() { 
          $(this).toggleClass("grid--1-col-tablet-down");
          $(this).removeClass("grid--3-col-tablet-down").addClass("grid--1-col-tablet-down");
          $(this).css("display", "block");
      });
    });

    $('#due-s').click(function(){
      $('.grid--1-col-tablet-down').toggle(function() {
          $(this).toggleClass("grid--2-col-tablet-down");
          $(this).removeClass("grid--1-col-tablet-down").addClass("grid--2-col-tablet-down");
          $(this).css("display", "flex");
      }, function() { 
          $(this).toggleClass("grid--2-col-tablet-down");
          $(this).removeClass("grid--1-col-tablet-down").addClass("grid--2-col-tablet-down");
          $(this).css("display", "flex");
      });
      $('.grid--3-col-tablet-down').toggle(function() {
          $(this).toggleClass("grid--2-col-tablet-down");
          $(this).removeClass("grid--3-col-tablet-down").addClass("grid--2-col-tablet-down");
          $(this).css("display", "flex");
      }, function() { 
          $(this).toggleClass("grid--2-col-tablet-down");
          $(this).removeClass("grid--3-col-tablet-down").addClass("grid--2-col-tablet-down");
          $(this).css("display", "flex");
      });
    });

    $('#three-s').click(function(){
      $('.grid--1-col-tablet-down').toggle(function() {
          $(this).toggleClass("grid--3-col-tablet-down");
          $(this).removeClass("grid--1-col-tablet-down").addClass("grid--3-col-tablet-down");
          $(this).css("display", "flex");
      }, function() { 
          $(this).toggleClass("grid--3-col-tablet-down");
          $(this).removeClass("grid--1-col-tablet-down").addClass("grid--3-col-tablet-down");
          $(this).css("display", "flex");
      });
      $('.grid--2-col-tablet-down').toggle(function() {
          $(this).toggleClass("grid--3-col-tablet-down");
          $(this).removeClass("grid--2-col-tablet-down").addClass("grid--3-col-tablet-down");
          $(this).css("display", "flex");
      }, function() { 
          $(this).toggleClass("grid--3-col-tablet-down");
          $(this).removeClass("grid--2-col-tablet-down").addClass("grid--3-col-tablet-down");
          $(this).css("display", "flex");
      });
    });
    
});




$(document).ready(function(){
  $(".collection_description").text(function(index, currentText) {
    var maxLength = $(this).attr('data-maxlength');
    if(currentText.length >= maxLength) {
      return currentText.substr(0, maxLength) + "...";
    } else {
      return currentText
    } 
  });
  
  $('.coll_tab_img_tab .wrap_characterbest .list_category li').eq(0).addClass('active');
  $('.coll_tab_img_tab .flicking-camera .panel').eq(0).addClass('active');
  $(".toggle").click(function(){
    $("#myPopup").toggleClass("hide");
  });

  $("#myPopup .close").click(function(){
    $("#Details-menu-drawer-container").removeClass("menu-opening");
    $("#Details-menu-drawer-container").removeAttr("open");
    $("#Details-menu-drawer-container .header__icon").attr("aria-expanded","false");
  });
});

//pre-album slider code


$(function () {
  $(".popup-body h2 a").click(function () {
    $(".popup-body h2").removeClass("active");
    $(this).parent().addClass("active");
    let currentTab = $(this).attr("href");
    $(".menu_outer div").hide();
    $(currentTab).show();
    return false;
  });
});
sc_up_arrow = document.getElementById("sc_up_arrow");
var myScrollFunc = function () {
    var y = window.scrollY;
    if (y >= 500) {
        sc_up_arrow.className = "top_bottom show"
    } else {
        sc_up_arrow.className = "top_bottom hide"
    }
};
window.addEventListener("scroll", myScrollFunc);

social_listing_fix = document.getElementById("social-listing-fix");
var myScrollFunc2 = function () {
    var yh = window.scrollY;
    if (yh >= 500) {
        social_listing_fix.className = "social-listing-fix show"
    } else {
        social_listing_fix.className = "social-listing-fix hide"
    }
};
window.addEventListener("scroll", myScrollFunc2);

footer_menu_m = document.getElementById("footer_menu");
var Footer_Menu_M = function () {
    var yh = window.scrollY;
    if (yh >= 10) {
        footer_menu_m.className = "footer_menu show"
    } else {
        footer_menu_m.className = "footer_menu hide"
    }
};
window.addEventListener("scroll", Footer_Menu_M);







window.onscroll = function() {myFunction()};

var header = document.getElementById("right-left-pop");

var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

